import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import root from 'window-or-global';
import { LayoutProvider } from '~/features/common/redux/context';
import OneSignal from '~/common/onesignal';

/*
  This is the root component of your app. Here you define the overall layout
  and the container of the react router.
  You should adjust it according to the requirement of your app.
*/

export default class App extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
  };

  static defaultProps = {
    children: '',
  };

  UNSAFE_componentWillMount() {
    root.__COACH_HIDE_SIDEBAR = async dir => {
      await window.__STORE__.dispatch({
        type: 'COMMON_TOGGLE_SIDEBAR',
        dir: dir,
        value: false,
      });
      window.dispatchEvent(
        new CustomEvent('LayoutSidebarToggle', {
          detail: {
            value: false,
            dir: dir,
          },
          bubbles: true,
        }),
      );
    };
  }

  componentDidMount() {
    OneSignal.init();
  }

  render() {
    return (
      <div className="naluri-app">
        <LayoutProvider value={window.__STORE__.getState()['common']}>
          {this.props.children}
        </LayoutProvider>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/App.js